"use client";
import {useEffect} from "react";
import {Button} from "@/app/_components";
import GameTrack from "@/Core/GameTrack";
import styles from "./Step3_4_5.module.css";

type Step4Props = {
    target?: () => HTMLElement | null;
    currentStep?: number;
    currIndex: number;
    onNext?: (idx: number) => void;
}

const buttonStyle: React.CSSProperties = {
    color: "#fff",
    width: "3.7rem",
    height: "1.1rem",
    fontWeight: 900,
    fontSize: ".5rem"
}

const Step4: React.FC<Step4Props> = props => {
    const { target, currentStep, currIndex, onNext } = props;

    const _targetStyle = target?.()?.getBoundingClientRect();
    if (!_targetStyle) return;

    const { x, width, } = _targetStyle;
    const wrapperStyle: React.CSSProperties = {
        position: 'absolute',
        width: width,
        height: '1.95rem',
        bottom: 0,
        left: x,
    }

    useEffect(() => {
        return () => {
        };
    }, []);

    // const { viewportWidth } = useViewport();
    // let leftOrRight = x > (viewportWidth / 2) ? 'right' : 'left';
    // const stepStyle: React.CSSProperties = {}
    // if (leftOrRight === 'left') {
    //     stepStyle.left = x;
    // } else {
    //     stepStyle.right = '0 !important';
    // }

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // e.stopPropagation();
        // onNext && onNext(currIndex + 1)
    }

    return (
        <>
            {(currentStep === currIndex) && <div style={wrapperStyle} >
                <div className={styles.step3}>
                    <img src="/img/guide/Rewards.webp" style={{width: width > 129 ? 129 : width}} alt=""/>
                    <div className={styles.arrow}></div>
                    <div className={`${styles.popover} ${styles.popover_step4}`}>
                        Check out <span style={{color: '#EE8A08', fontWeight: 900}}>REWARDS</span> for each free or rich
                        gifts !
                        <div className={`${styles.button} ${styles.button_step4}`}>
                            <Button color="#0090FF" style={buttonStyle} onClick={handleClick}>Exciting!</Button>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default Step4;